import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import classnames from 'classnames'
import _ from 'lodash'
import { toast } from 'react-toastify'
import Recaptcha from 'react-recaptcha'
import { TextField, Typography, Button, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

import { confirmRecoverPassword } from 'services/apiAuth'
import { isNetworkError, isPasswordValid } from 'utils/functions'

import styles from './styles'

const PasswordConfirmRecover = () => {
  const classes = styles()
  const history = useHistory()

  const email = useSelector(state => state.auth.destination)

  const [code, setCode] = useState('')
  const [usernameEmail, setUsernameEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [recaptchaToken, setRecaptchaToken] = useState(null)

  const handleSubmit = async () => {
    setLoading(true)
    setError(false)

    try {
      const formData = new FormData()
      formData.append('code', code)
      formData.append('username_email', usernameEmail)
      formData.append('password', password)
      formData.append('app_id', process.env.REACT_APP_COGNITO_APP_ID)
      formData.append('user_pool', process.env.REACT_APP_COGNITO_USER_POOL)
      formData.append('recaptcha_token', recaptchaToken)

      const res = await confirmRecoverPassword(formData)

      if (res.status === 200) {
        setLoading(false)

        return history.push('/login')
      }
    } catch (err) {
      setLoading(false)
      setIsVerified(false)
      setRecaptchaToken(null)

      if (!isNetworkError(err)) {
        const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao confirmar senha'
        toast.error(messageError)
      }

      return null
    }

    return null
  }

  const verifyCaptcha = response => {
    if (response) {
      setIsVerified(true)
      setRecaptchaToken(response)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>
        <img src="/assets/images/logos/logo.svg" alt="Logo" className={classes.logo} />
        <div className={classes.titleSidebarContainer}>
          <h1 className={classes.titleSidebar}>Confirmar Cadastro</h1>
          <p className={classes.subtitleSidebar}>Faça a confirmação do cadastro em que será alterada a senha!</p>
        </div>
      </div>
      <div className={classes.main}>
        <h1 className={classes.title}>Digite o código recebido por email:</h1>
        <p>
          O código foi enviado para o email:
          {email}
        </p>
        <div className={classes.inputsContainer}>
          <form className={classes.formContainer}>
            <TextField
              id="code"
              label="Código recebido por email"
              className={classes.textField}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoComplete="off"
              type="number"
              required={true}
              autoCorrect="off"
              autoCapitalize="off"
            />
            <TextField
              id="email"
              label="Nome de Usuário ou E-mail utilizado"
              className={classes.textField}
              value={usernameEmail}
              onChange={(e) => setUsernameEmail(e.target.value)}
              type="email"
              required={true}
              autoCorrect="off"
              autoCapitalize="off"
            />
            <TextField
              id="password"
              label="Senha"
              className={classes.textField}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              type="password"
              required={true}
              autoCorrect="off"
              autoCapitalize="off"
              error={password.length !== 0 ? !isPasswordValid(password) : false}
              helperText={
                password.length !== 0
                  ? isPasswordValid(password)
                    ? false
                    : 'A senha precisa ter pelo menos 1 letra maiuscula, 1 minuscula, 1 número e um caracter especial, e no mínimo de 8 caracteres.'
                  : false
              }
            />
          </form>
          {error ? (
            <p>
              <strong className={classes.error}>
                Já existe uma conta cadastrada com esse email.
                <br />
                Por favor, refaça o cadastro utilizando um email diferente.
              </strong>
            </p>
          ) : null}
        </div>

        <div className={classes.buttonContainer}>
          <div className={isVerified ? classes.noDisplay : ''}>
            <Recaptcha
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              render="explicit"
              expiredCallback={() => {}}
              onloadCallback={() => {}}
              verifyCallback={verifyCaptcha}
              hl="pt-BR"
            />
          </div>
          <Button
            color="primary"
            variant="contained"
            className={classnames(classes.button, !isVerified ? classes.noDisplay : '')}
            onClick={handleSubmit}
            disabled={!!loading}
          >
            {
              loading
              ? <CircularProgress className={classes.progress} />
              : 'Acessar'
            }
          </Button>

          <Typography>
            Lembrei minha senha.
            {' '}
            <Link to="/login">Entrar</Link>
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(PasswordConfirmRecover)
